var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValveBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 3.75C13.375 2.98945 12.7605 2.375 12 2.375C11.2395 2.375 10.625 2.98945 10.625 3.75V4.3L5.125 3.75V6.5L12 5.8125L18.875 6.5V3.75L13.375 4.3V3.75ZM13.375 7.36797L12 7.19609L10.625 7.36797V9.25H5.125V20.25H18.875V9.25H13.375V7.36797ZM3.75 7.875H1V9.25V20.25V21.625H3.75V20.25V9.25V7.875ZM23 9.25V7.875H20.25V9.25V20.25V21.625H23V20.25V9.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValveBlack);
export default __webpack_public_path__ + "static/media/valve-black.7b9b7bade37531693726a122aa770fe8.svg";
export { ForwardRef as ReactComponent };